import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { PageNotFound } from '../../PageNotFound';
import { LanguageLearningBundlesPage } from './LanguageLearningBundlesPage';
import { CheckLoanFormat } from '../../../shared/components/CheckLoanFormat';

export const BundlesRouteSwitch = () => {
    const match = useRouteMatch();
    return (
        <Switch>
            <Redirect exact from={`${match.url}`} to={`${match.url}/all`} />
            <Route
                exact
                path={`${match.url}/:loanFormat?`}
                render={() => (
                    <CheckLoanFormat>
                        <LanguageLearningBundlesPage />
                    </CheckLoanFormat>
                )}
            />
            <Route component={PageNotFound} />
        </Switch>
    );
};
